<script setup>
import {toRefs, computed} from 'vue'

//Props
const props = defineProps({
  value: {
    type: [String, Number, Array],
    default: null,
  },
  options: {
    type: Array,
    default: () => [],
  },
  showUnknown: {
    type: Boolean,
    default: false,
  },
  showOther: {
    type: Boolean,
    default: false,
  },
  showValueForOther: {
    type: Boolean,
    default: false,
  },
  unknownLabel: {
    type: String,
    default: 'Unknown',
  },
  otherLabel: {
    type: String,
    default: 'Other',
  },
  labelProp: {
    type: String,
    default: 'label',
  },
  valueProp: {
    type: String,
    default: 'value',
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
})

//Get refs
const {
  value,
  options,
  showUnknown,
  showOther,
  showValueForOther,
  unknownLabel,
  otherLabel,
  labelProp,
  valueProp,
} = toRefs(props)

//Helper to get label value of an option
const getLabel = optionValue => {

  //Find option
  const option = options.value.find(option => option[valueProp.value] === optionValue)
  if (option) {
    return option[labelProp.value]
  }

  //Option not found, but there is a value, show other label
  else if (optionValue && showOther.value) {
    if (showValueForOther.value) {
      return optionValue
    }
    return otherLabel.value
  }

  //Show unknown label
  else if (showUnknown.value) {
    return unknownLabel.value
  }

  //Blank
  return ''
}

//Determine label
const label = computed(() => {
  if (Array.isArray(value.value)) {
    return value.value
      .map(getLabel)
      .join(', ')
  }
  return getLabel(value.value)
})
</script>

<template>
  <span>{{ prefix }}{{ label }}{{ suffix }}</span>
</template>
